import * as React from 'react';
import { DataCy } from '../../../../types/dataAttributes';
import { JRCFormFieldRenderer } from '../Common/JRCFormFieldRenderer';
import { ContainerInputTextIconButton, InputIconButton, IconBefore, IconAfter } from './JRCInputText.style';

export type JRCInputTextIconButtonProps = DataCy &
    React.ComponentPropsWithoutRef<'input'> & {
        iconBefore: string;
        iconButtonAfter?: {
            icon: string;
            onClick: () => void;
        };
    };

const InputTextIconButtonElement = function (
    { iconBefore = 'icon-search', iconButtonAfter, ...props }: JRCInputTextIconButtonProps,
    ref: React.ForwardedRef<HTMLInputElement>,
) {
    const [focused, setFocused] = React.useState<boolean>(false);
    const onFocus = () => setFocused(true);
    const onBlur = () => setFocused(false);
    return (
        <ContainerInputTextIconButton>
            {iconBefore && <IconBefore name={iconBefore} color={focused ? 'navy' : 'grey2'} />}
            <InputIconButton
                type="text"
                id={props.name}
                {...props}
                ref={ref}
                onFocus={onFocus}
                onBlur={onBlur}
                hasIconButtonAfter={Boolean(iconButtonAfter)}
            />
            {iconButtonAfter && <IconAfter icon={iconButtonAfter.icon} onClick={iconButtonAfter.onClick} />}
        </ContainerInputTextIconButton>
    );
};
export const InputTextIconButton = React.forwardRef(InputTextIconButtonElement);

export function JRCInputTextIconButton(props: any) {
    return (
        <JRCFormFieldRenderer {...props} renderFunction={(field) => <InputTextIconButton {...props} {...field} />} />
    );
}
